import React from 'react';

import { ITaskInfo } from '@/entities/task/model/client';
import { WeeklyWorkLog } from '@/types';

import { FieldConfig } from '../config/fields';

export type ProcessedField = {
  field: FieldConfig;
  value: React.ReactNode | null;
};

export const getProcessedFields = (
  fieldsConfig: FieldConfig[],
  log: WeeklyWorkLog | null,
  task: ITaskInfo | null,
  group?: 'time' | 'general',
): ProcessedField[] => {
  const filteredFields = group
    ? fieldsConfig.filter((field) =>
        group === 'time' ? field.group === 'time' : field.group !== 'time',
      )
    : fieldsConfig;

  return filteredFields.map((field) => ({
    field,
    value: log ? field.getValue(log, task) : task ? field.getValue(null as any, task) : null,
  }));
};
